export default __webpack_public_path__ + "efb663fa46c564cadfdaafaab187ff32.png";